import { render, staticRenderFns } from "./KnowledgeContentView.vue?vue&type=template&id=38ea1f84&"
import script from "./KnowledgeContentView.vue?vue&type=script&lang=js&"
export * from "./KnowledgeContentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports